import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { get } from "../api/axios"
import endpoints from "../api/endpoints"
import { resolveAdminCityName } from "../helpers/adminCity"

const resolveUserCityName = user => {
  if (!user) return ""
  const cityLike =
    user.city ||
    user.active_city ||
    user.activeCity ||
    (user.city_name || user.cityName
      ? { name: user.city_name || user.cityName }
      : null)
  return resolveAdminCityName(cityLike)
}

const resolveUserCityId = user =>
  user?.city_id ||
  user?.cityId ||
  user?.city?.id ||
  user?.active_city?.id ||
  user?.activeCity?.id ||
  ""

/**
 * Resolve a Manage City label from router state, then admin cities list.
 */
const useAdminCityName = cityId => {
  const location = useLocation()
  const currentUser = useSelector(state => state.auth.currentUser)
  const cityFromNav = location.state?.city
  const userCityId = resolveUserCityId(currentUser)
  const [cityName, setCityName] = useState(() => {
    if (cityId && cityFromNav && String(cityFromNav.id) === String(cityId)) {
      return resolveAdminCityName(cityFromNav)
    }
    if (cityId && userCityId && String(userCityId) === String(cityId)) {
      return resolveUserCityName(currentUser)
    }
    return ""
  })

  useEffect(() => {
    if (!cityId) {
      setCityName("")
      return undefined
    }

    if (cityFromNav && String(cityFromNav.id) === String(cityId)) {
      const resolved = resolveAdminCityName(cityFromNav)
      if (resolved) {
        setCityName(resolved)
      }
    } else if (userCityId && String(userCityId) === String(cityId)) {
      const fromUser = resolveUserCityName(currentUser)
      if (fromUser) {
        setCityName(fromUser)
      }
    }

    let cancelled = false

    const loadCityName = async () => {
      try {
        const response = await get(endpoints.getAdminCities, {
          params: { page: 1, page_size: 200 },
          skipErrorToast: true,
        })
        if (cancelled || !response?.data?.success) return
        const rows = response.data.result?.data || []
        const match = rows.find(item => String(item.id) === String(cityId))
        if (!match) return
        setCityName(resolveAdminCityName(match))
      } catch {
        // Keep navigation or user fallback when available.
      }
    }

    loadCityName()
    return () => {
      cancelled = true
    }
  }, [cityFromNav, cityId, currentUser, userCityId])

  return cityName
}

export default useAdminCityName
